const TITLE_MAP = {
  TECHNICIAN: 'app.pricing.type.techlicense.title',
  ALL_ASSET: 'app.pricing.type.allassets.title',
  END_POINT_ASSET: 'app.pricing.type.endpoints.title',
  NETWORK_ASSET: 'app.pricing.type.networkMonitor',
  MDM_ASSET: 'common.mdm'
};

const DESC_MAP = {
  TECHNICIAN: 'admin.billing.technician.utilised.description',
  ALL_ASSET: 'app.pricing.type.allassets.description',
  END_POINT_ASSET: 'admin.billing.asset.utilised.description',
  NETWORK_ASSET: 'admin.billing.asset.utilised.description',
  MDM_ASSET: 'admin.billing.asset.utilised.description'
};

export { TITLE_MAP, DESC_MAP };
